import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSite, TeamMember } from '../context/SiteContext';
import { FrontEndRoutes } from '../config/front-end-routes';

const TeamPreview: React.FC = () => {
  const { team, imageUrl } = useSite();

  const getPhotoUrl = (member: TeamMember): string => {
    if (member.photo?.image_path) return imageUrl(member.photo.image_path);
    if (member.profile_photo) return imageUrl(member.profile_photo);
    return '';
  };

  if (team.length === 0) return null;

  return (
    <section className="py-5 bg-white">
      <Container>
        <Row className="text-center mb-5">
          <Col>
            <h2 className="display-5 fw-bold text-profile-1 mb-3">Nossa Equipe de Especialistas</h2>
            <div className="bg-profile-3" style={{ width: '80px', height: '4px', margin: '0 auto' }}></div>
            <p className="mt-4 text-muted">Profissionais altamente qualificados e certificados.</p>
          </Col>
        </Row>
        <Row className="g-4 justify-content-center">
          {team.slice(0, 4).map(member => (
            <Col lg={3} md={6} key={member.id}>
              <Card className="h-100 shadow-sm border-0 hover-card">
                <Card.Body className="text-center p-4">
                  <div className="mx-auto mb-3 rounded-circle overflow-hidden" style={{ width: '120px', height: '120px' }}>
                    {getPhotoUrl(member) ? (
                      <img
                        src={getPhotoUrl(member)}
                        alt={member.user_name}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }}
                      />
                    ) : (
                      <div className="h-100 bg-profile-5 d-flex align-items-center justify-content-center">
                        <i className="fas fa-user-md fs-1 text-profile-3"></i>
                      </div>
                    )}
                  </div>
                  <Card.Title className="text-profile-1 fw-bold">{member.user_name}</Card.Title>
                  <p className="text-profile-3 fw-semibold mb-2">{member.tipo}</p>
                  {member.cro_number && (
                    <p className="text-muted small mb-3">CRO/{member.cro_uf} {member.cro_number}</p>
                  )}
                  <div className="d-flex justify-content-center gap-2">
                    {member.instagram_handle && (
                      <a href={`https://instagram.com/${member.instagram_handle}`} target="_blank" rel="noopener noreferrer" className="text-profile-1 p-1 btn btn-link">
                        <i className="fab fa-instagram"></i>
                      </a>
                    )}
                    {member.user_email && (
                      <a href={`mailto:${member.user_email}`} className="text-profile-1 p-1 btn btn-link">
                        <i className="fas fa-envelope"></i>
                      </a>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <Row className="text-center mt-5">
          <Col>
            <Link to={FrontEndRoutes.TEAM}>
              <Button variant="primary" size="lg" className="bg-profile-1 border-profile-1">
                Conheça toda nossa equipe
              </Button>
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TeamPreview;
